/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from 'react'
import WeeklyCalendar, {
  IWeeklyCalendarProps
} from '../WeeklyCalendar/WeeklyCalendar'
import LMSWeeklyCalendar from './LMSWeeklyCalendar'
import { CALENDAR_TYPE } from '../../../constants'

export default function LMSModeWeeklyCalendar({
  startDate,
  endDate,
  events,
  norms,
  showWeeklyNorm = false,
  onOpenDetail,
  onOpenCreate,
  onEventDetail,
  loading
}: IWeeklyCalendarProps) {
  const [windowWidth, setWindowWidth] = useState(window.innerWidth)

  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth)
    }

    window.addEventListener('resize', handleResize)

    return () => {
      window.removeEventListener('resize', handleResize)
    }
  }, [])

  return (
    <React.Fragment>
      {windowWidth > 1024 ? (
        <WeeklyCalendar
          startDate={startDate}
          endDate={endDate}
          events={events}
          norms={norms}
          showWeeklyNorm={showWeeklyNorm}
          onOpenDetail={onOpenDetail}
          onOpenCreate={onOpenCreate}
          onEventDetail={onEventDetail}
          loading={loading}
          type={CALENDAR_TYPE.LMS}
        />
      ) : (
        <LMSWeeklyCalendar
          startDate={startDate}
          endDate={endDate}
          events={events}
          norms={norms}
          onOpenDetail={onOpenDetail}
          onOpenCreate={onOpenCreate}
          onEventDetail={onEventDetail}
          loading={loading}
          type={CALENDAR_TYPE.LMS}
        />
      )}
    </React.Fragment>
  )
}
